module.exports = __webpack_public_path__ + "img/c.52d210af.svg";